import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { AuthService, DataCenterListService, LoginService } from 'src/app/services';

@Component({
    selector: 'haven-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class HeaderComponent implements OnInit {
  loggedInUser: string;
  constructor(private authService: AuthService, private dataCenterListService: DataCenterListService, private loginService: LoginService) {}

  ngOnInit() {
    this.loggedInUser = this.authService.getUserFullName();
  }
  onLogout() {
    this.loginService.logout().subscribe(
      (result) => {
        this.authService.deleteCookies();
        this.authService.logout();
      }
    );
  }
}
